import { ComplianceAuditStatistics } from '@client/components/compliance-audit/ComplianceAuditStatistics';
import { createFileRoute } from '@tanstack/react-router';

// Admin-console statistics overlay — opened from the compliance-audit monitoring
// table. The component fetches its own data and renders the OverlayPage; passing
// `orgId` selects the cross-org admin endpoint (admins sit in the system console
// org, so the audit is scoped by the explicit tenant `orgId`). Close returns to
// the monitoring table.

export const Route = createFileRoute('/admin-console/monitoring/compliance-audit/$orgId/$complianceAuditId/statistics')(
    {
        staticData: {
            presentation: 'overlay',
            metadata: {
                title: 'Audit statistics',
            },
        },
        params: {
            parse({ orgId, complianceAuditId }) {
                return { orgId: BigInt(orgId), complianceAuditId: BigInt(complianceAuditId) };
            },
        },
        component: RouteComponent,
    },
);

function RouteComponent() {
    const { orgId, complianceAuditId } = Route.useParams();
    return <ComplianceAuditStatistics orgId={orgId} complianceAuditId={complianceAuditId} />;
}
